var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',_vm._l(([5, 4, 3, 2, 1]),function(v,i){return _c('Card',{key:i,staticClass:"mb-5"},[_c('v-skeleton-loader',{staticClass:"d-flex flex-wrap align-center ga-3 px-6 py-4"},[_c('span',{staticClass:"avatar mr-3 v-skeleton-loader__bone",style:({
						'background-color': `rgba(153, 153, 153, 0.${v})`,
					})}),_c('span',{staticClass:"paragraph v-skeleton-loader__bone",style:({
						width: v % 2 !== 0 ? '191px' : '143px',
						'background-color': `rgba(153, 153, 153, 0.${v})`,
					})})])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }